import React from "react";

/**
 * React 19 native document metadata.
 * <title>, <meta>, <link> rendered inside any component are automatically
 * hoisted to <head> and de-duplicated.
 */
export default function SEO({ title, description, path = "/", image }) {
  const url = `https://restrosetup.com${path}`;
  const fullTitle = title ? `${title} — RestroSetup` : "RestroSetup — Zomato & Swiggy Profile Optimization for Restaurants";
  const desc = description || "More customers. Better orders. Higher menu scores. Profile tuning, menu design, food photography & brand identity for hotels and restaurants.";
  const img = image || "https://restrosetup.com/og-image.jpg";
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </>
  );
}
